










































import { Component } from 'vue-property-decorator';
import MetricPage from '@/components/analytics/MetricPage.vue';
import { namespace } from 'vuex-class';
import VWrapper from '@/components/shared/VWrapper.vue';
import VRangePicker from '@/components/shared/form/VRangePicker.vue';
import AnalyticsLoader from '@/components/analytics/AnalyticsLoader.vue';
import { Venue } from '@/interfaces/models/Venue';
import ExportWidget from '@/components/shared/ExportWidget.vue';
import OrderServiceApi from '@/api/http/OrderServiceApi';
import { OrderFlavor } from '@/enums/OrderFlovor';
import { AxiosResponse } from 'axios';
import { toUrl } from '@/util/helper';
import Notification from '@/mixins/Notification';
import moment from 'moment';
import PaymentApiService from '@/api/http/PaymentApiService';
import { CustomerGroup } from '@/enums/CustomerGroup';
import { mixins } from 'vue-class-component';
import { Download } from '@/interfaces/models/Download';
import { VenueLabel } from '@/interfaces/models/VenueLabel';
import { Permission } from '@/enums/Permission';

const app = namespace('app');
const label = namespace('venueLabel');
const download = namespace('download');

interface ExportFormData {
  venue: string;
  flavor: OrderFlavor;
  from: string;
  to: string;
  lang?: string;
  labels?: string[];
}

@Component({
  components: { ExportWidget, AnalyticsLoader, VRangePicker, MetricPage, VWrapper },
})
export default class Billing extends mixins(Notification) {
  @app.State('venues') public venues!: Venue[];
  @label.State('items') public labels!: VenueLabel[];

  @label.Action('fetch') getLabels!: any;

  @download.Action('addDownload') public addDownload!: (d: Download) => void;

  async mounted() {
    if (this.$can(Permission.LABEL_VIEW)) {
      await this.getLabels();
    }
  }

  public exportOrderCsv(data: ExportFormData) {
    this.$startLoading('orderCsv');
    const api: OrderServiceApi = new OrderServiceApi();
    api
      .orderCsv({ ...data, lang: this.$i18n.locale })
      .then((res: AxiosResponse) => toUrl(res.data, `orders-${moment().format('DD-MM-YYYY')}.csv`))
      .finally(() => {
        this.$stopLoading('orderCsv');
      });
  }

  public exportOrderPaymentMethodCsv(data: ExportFormData) {
    this.$startLoading('orderPaymentMethodCsv');
    const api: OrderServiceApi = new OrderServiceApi();
    api
      .orderPaymentMethodCsv({ ...data, lang: this.$i18n.locale })
      .then((res: AxiosResponse) => toUrl(res.data, `orders-${moment().format('DD-MM-YYYY')}.csv`))
      .finally(() => {
        this.$stopLoading('orderPaymentMethodCsv');
      });
  }

  public getCustomerGroup(data: ExportFormData): CustomerGroup {
    if (data.venue) {
      const venue: Venue = this.venues.find((v: Venue) => v._id === data.venue)!;
      if (venue) {
        return venue.customerGroup;
      }
    }

    return CustomerGroup.Default;
  }

  public exportBillingSummary(data: ExportFormData) {
    const api: PaymentApiService = new PaymentApiService();
    if (
      this.getCustomerGroup(data) === CustomerGroup.Subway ||
      this.getCustomerGroup(data) === CustomerGroup.SubwayFr
    ) {
      api.billingSummaryPdfSubway({ ...data, lang: this.$i18n.locale }).then((res: AxiosResponse<{ file: string }>) => {
        this.addDownload({ file: res.data.file, timeout: 60, handler: 'payment', inProgress: false, done: false });
        this.notifyInfo('notification.downloadInProgress');
      });
    } else {
      api.billingSummaryPdf(data).then((res: AxiosResponse<{ file: string }>) => {
        this.addDownload({ file: res.data.file, timeout: 60, handler: 'payment', inProgress: false, done: false });
        this.notifyInfo('notification.downloadInProgress');
      });
    }
  }

  public exportBilling(data: ExportFormData) {
    const api: PaymentApiService = new PaymentApiService();
    if (
      this.getCustomerGroup(data) === CustomerGroup.Subway ||
      this.getCustomerGroup(data) === CustomerGroup.SubwayFr
    ) {
      api.billingPdfSubway({ ...data, lang: this.$i18n.locale }).then((res: AxiosResponse<{ file: string }>) => {
        this.addDownload({ file: res.data.file, timeout: 60, handler: 'payment', inProgress: false, done: false });
        this.notifyInfo('notification.downloadInProgress');
      });
    } else {
      api.billingPdf(data).then((res: AxiosResponse<{ file: string }>) => {
        this.addDownload({ file: res.data.file, timeout: 60, handler: 'payment', inProgress: false, done: false });
        this.notifyInfo('notification.downloadInProgress');
      });
    }
  }
}
